<template>
  <v-main app>
      <v-layout column fill-height class="pa-1">
          <v-fade-transition mode="out-in">
              <router-view />
          </v-fade-transition>
          <a href="https://www.freepik.com/vectors/background">Background vector created by renata.s - www.freepik.com</a>
      </v-layout>
  </v-main>
</template>

<script>
export default {
  name: "AppMain",
};
</script>

<style lang="scss" scoped>
a {
  display: none;
}

main {
  height: 100vh;
}
.theme--light {
  main {
      background-color: map-get($grey, 'lighten-3');
  }
}
</style>